import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";
// new change -- for get user model object
import { User } from "../_models/user";
import { AuthenticationService } from "../_services/authentication.service";
import { EnvironmentService } from "./index";

@Injectable()
export class UserAdminService {
  private baseUrl: string = this.environmentService.getBaseURL() + "/api";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}
  getAll(): Observable<User[]> {
    let users$ = this.http
      .get(`${this.baseUrl}/users`, this.makeHeaders())
      .map(mapUsers)
      .catch(handleError);
    return users$;
  }
  get(id: string): Observable<User> {
    let user = this.http
      .get(
        `${this.baseUrl}/users/${id}`,
        this.makeHeaders()
      )
      .map(mapUser);
    return user;
  }
  create(user: Partial<User>): Observable<User> {
    let newuser = this.http
      .post(
        `${this.baseUrl}/users`,
        JSON.stringify(user),
        this.makeHeaders()
      )
      .map(mapUser);
    return newuser;
  }
  update(user: Partial<User>): Observable<User> {
    let updateduser = this.http
      .put(
        `${this.baseUrl}/users/${user._id}`,
        JSON.stringify(user),
        this.makeHeaders()
      )
      .map(mapUser);
    return updateduser;
  }
  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/users/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }

  private makePostHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");
    headers.append("Method", "POST");
    headers.append("Access-Control-Allow-Origin", "*");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapUsers(response: Response): User[] {
    // uncomment to simulate error:
    // throw new Error('ups! Force choke!');
    return response.json().map(toUser);
  }
function toUser(r: any): User {
    let user = <User>{
      _id: r._id,
      email: r.email,
      fullname: r.fullname,
      isadmin: r.isadmin,
      dealerid: r.dealerid
    };
    return user;
  }
function mapUser(response: Response): User {
    // toPerson looks just like in the previous example
    return toUser(response.json());
  }
// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/useradmin.service.ts